import PasswordEditFields from '@/views/backstage/structure/system_management_page/account_management_page/common/PasswordEditFields'

let password_edit_structure = {
    name: '變更密碼',
    type: 'group',
    fields: [].concat(
        PasswordEditFields['username'],
        PasswordEditFields['org_name'],
        PasswordEditFields['email'],
        PasswordEditFields['original_password'],
        PasswordEditFields['new_password'],
        PasswordEditFields['confirm_password'],
    )
}

export default () => {
    return password_edit_structure
}